/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Dialog_Text_To_Audio_Listening_Time_Hours_MinutesInputs */

const en_dialog_text_to_audio_listening_time_hours_minutes = /** @type {(inputs: Dialog_Text_To_Audio_Listening_Time_Hours_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.hours}h ${i?.minutes}m`)
};

const es_dialog_text_to_audio_listening_time_hours_minutes = /** @type {(inputs: Dialog_Text_To_Audio_Listening_Time_Hours_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.hours} h ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "~{hours}h {minutes}m" |
*
* @param {Dialog_Text_To_Audio_Listening_Time_Hours_MinutesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_listening_time_hours_minutes = /** @type {((inputs: Dialog_Text_To_Audio_Listening_Time_Hours_MinutesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Listening_Time_Hours_MinutesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_listening_time_hours_minutes(inputs)
	return en_dialog_text_to_audio_listening_time_hours_minutes(inputs)
});